module.exports = __webpack_public_path__ + "static/media/arrow-svgrepo-com (5).49092f60.svg";